import {
  Component,
  ElementRef,
  HostListener,
  ModuleWithProviders,
  ViewChild,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  HttpClient,
  HttpClientModule,
  HttpHeaders,
} from '@angular/common/http';
import swal from 'sweetalert2';
import { ApidataService } from '../apidata.service';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { Router, NavigationEnd } from '@angular/router';
import { jsPDF } from 'jspdf';
import { saveAs } from 'file-saver';
import { FooterComponent } from '../footer/footer.component';
import html2canvas from 'html2canvas';
import { MetaTagService } from '../meta-tag.service';
import { environment, GINConstants } from '../../environments/environments';
import { FeedbackComponent } from '../feedback/feedback.component';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { PremiumComponent } from "../premium/premium.component";
import { PremiumModalStartupComponent } from '../premium-modal/premium-modal.component';
declare var $: any;
declare var Dropbox: any;
declare var gapi: any;
declare var google: any;
declare var FB: any;
declare var window: any;
@Component({
  selector: 'app-plagiarism',
  standalone: true,
  imports: [
    HeaderComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgCircleProgressModule,
    FooterComponent,
    FeedbackComponent,
    IconsFreeToolsComponent,
    PremiumComponent,
    PremiumModalStartupComponent,
],
  templateUrl: './plagiarism.component.html',
  styleUrl: './plagiarism.component.css',
  providers: [
    ApidataService,
    (
      NgCircleProgressModule.forRoot({
        radius: 100,
        outerStrokeWidth: 16,
        innerStrokeWidth: 8,
        outerStrokeColor: '#78C000',
        innerStrokeColor: '#C7E596',
        animationDuration: 300,
      }) as ModuleWithProviders<NgCircleProgressModule>
    ).providers!,
  ],
})
export class PlagiarismComponent implements OnInit{
  public showfeedbackloader: boolean = false;
  public eFsubIF: boolean = false;
  Paragraphmode: boolean = true;
  Sentencesmode: boolean = false;
  public loaderAlert: boolean = false;
  ifsub: boolean = false;
  isUserLoggedin: boolean = false;
  public can_check_plag: boolean = true;
  public showPlagResults = true;
  public showPlagTab = true;
  public yesunique: boolean = false;
  isDropdownVisible = false;
  public plagresponse: boolean = false;
  public menuafterresponse: boolean = false;
  public copiedtext: boolean = false;
  showParagraph: boolean = true;
  private isContentCleared = false;
  mode_para: boolean = false;
  sentence_mode: boolean = false;
  public send25: boolean = false;
  public showbuttons: boolean = false;
  public showbottombuttons: boolean = false;
  public cleartxtbtn: boolean = false;
  error: boolean = false;
  success: boolean = false;
  public showpdfhtml: boolean = false;
  public mobilescreen: boolean = false;
  public responseformodbile: boolean = false;
  public color: string = 'black';
  selectedTab: string = 'tab1';
  public esubText: string = '';
  public esubText2: string = '';
  public plagExcludeUrl = '';
  editortxt = '';
  public copried_txt: string = '';
  excludeURL: string = '';
  checkURL: string = '';
  successAlert;
  activeTab: string = '';
  editorTxtAI: string;
  public editortxtforpdf = '';
  previousSpanId = '';
  activeDropdown: string = '';
  public form_message: any;
  public form_email: any;
  public getdomcontent_txt: any;
  eFsubText2: any;
  public oldUnderlineSpan = -1;
  selectedValue: number;
  stars: number[] = [1, 2, 3, 4, 5];
  count = 5;
  char_count = 0;
  public summatches = 0;
  public oldUnderlineSpanPlag = -1;
  public sumofsources = 0;
  word_count = 0;
  previous_plagerism_index: number = null;

  dangerAlerts;
  public subscribed_user;
  public finalresult;
  public uniquefinal;
  public compleated;
  public totallenghtofplag;
  public newquery;
  public plagcontentid;
  public oneid;
  public chcekit;
  public counter;
  public querytesting;
  public alllist;
  public firstval;
  profile_id;
  errorAlerts;
  recaptcha_message = '';
  got_recpatcha: boolean = false;
  captchaToken: string | null = null;
  public matchesurl = [];
  public sourcesurl = [];
  public plagListings: any[] = [];

  public alllistoffilter: {};
  selectedLanguage = {
    name: 'English',
    icon: '../../assets/images/plagiarism checker1/language.svg',
  };
  public clientId =
    '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com';
  public scope = [
    'profile',
    'email',
    'https://www.googleapis.com/auth/drive.file',
  ].join(' ');
  public pickerApiLoaded = false;
  public oauthToken?: any;
  @ViewChild('fileInput') fileInput;
  @ViewChild('text') text: ElementRef;

  @ViewChild('editor', { static: false }) editor!: ElementRef<HTMLDivElement>;
  constructor(
    private cdr: ChangeDetectorRef,
    private httpClient: ApidataService,
    private https: HttpClient,
    private router: Router,
    private cd: ChangeDetectorRef,
    private metaService: MetaTagService
  ) {
    if (this.captchaVisible) {
      this.loadAndRenderTurnstile();
    }
  }

  plag_id(index) {}
  public ARCroute() {
    this.router.navigate(['/article-rewriter']);
  }

  shouldShowButton: boolean = false;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  //

  countStar(star) {
    this.selectedValue = star;
  }

  public eFormSubmission(event: any) {
    event.preventDefault();
    this.eFsubIF = false;
    $('#eFsubText2').hide();
    this.form_email = $('#form_email').val();
    this.form_message = $('#form_message').val();
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (this.form_message.length === 0) {
      this.color = '#721c24';
      this.eFsubText2 = 'Please provide the required fields';
      $('#form_message').val('').css('border-color', 'red');
      this.eFsubIF = true;
      $('#eFsubText2').show();
      setTimeout(function () {
        $('#eFsubText2').hide();
        $('#form_message').css('border-color', '#08ba9c');
        this.eFsubIF = false;
      }, 3000);
    } else {
      this.showfeedbackloader = true;
      const headers = new HttpHeaders({
        Authorization: environment.AuthorizationGIN,
      });
      this.https
        .post(
          environment.API_URL + '/api/feedbackForm',
          {
            email: this.form_email,
            comment: this.form_message,
            page_name: 'home',
            emotion: this.selectedValue,
          },
          { headers }
        )
        .subscribe(
          (response) => {
            this.showfeedbackloader = false;
            this.color = 'green';
            this.eFsubText2 = 'Form Submitted Successfully!';
            this.eFsubIF = true;
            $('#eFsubText2').show();
            setTimeout(function () {
              $('#eFsubText2').hide();
              this.eFsubIF = false;
            }, 3000);
            $('#form_email').val('').css('border-color', '#08ba9c');
            $('#form_message').val('').css('border-color', '#08ba9c');
          },
          (error) => {
            // console.error(error);
          }
        );
    }
  }

  checkMail() {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    this.form_email = $('#form_email').val();
    if (reg.test(this.form_email) === false) {
      this.color = '#721c24';
      this.dangerAlerts = 'Please provide correct Email';
      $('#form_email').val('').css('border-color', 'red');
      this.ifsub = true;
      $('#dangerAlerts').show();
      setTimeout(function () {
        $('#dangerAlerts').hide();
        $('#form_email').css('border-color', '#08ba9c');
        this.ifsub = false;
      }, 3000);
    }
  }

  getdomcontent() {
    this.getdomcontent_txt = $('#editor').html();
  }
  downloadpdffile() {
    this.loaderAlert = true;
    this.char_count = $('#editor').text().length;
    this.getdomcontent();

    var editortext = this.getdomcontent_txt.replace(
      /background:\s*none/g,
      'background-color: rgba(223, 147, 147, 0.49)'
    );
    const headers = new HttpHeaders({
      Authorization: environment.AuthorizationGIN,
    });

    this.https
      .post(
        environment.API_URL + '/api/plagReport',
        {
          plagiarized: this.finalresult,
          unique: this.uniquefinal,
          word: this.word_count,
          characters: this.char_count,
          editor_content: editortext,
          plagListings: this.plagListings,
        },
        { headers, responseType: 'blob' }
      )
      .subscribe(
        (response: Blob) => {
          saveAs(response, 'plagReport.pdf');
          this.loaderAlert = false;
        },
        (error) => {
          // console.error('Error:', error);
        }
      );
  }
  /// end download pdf file 
  clearfeedbackform() {
    this.selectedValue = 0;
    $('#form_email').val('').css('border-color', '#e7e7ec');
    $('#form_message').val('').css('border-color', '#e7e7ec');
  }

  textfromAI() {
    if (localStorage.getItem('editorValueAI')) {
      this.showParagraph = false;
    }
    setTimeout(() => {
      if (localStorage.getItem('editorValueAI')) {
        this.editorTxtAI = localStorage.getItem('editorValueAI');
        this.char_count = this.editorTxtAI.length;
        this.word_count = this.editorTxtAI.trim().split(/\s+/).length;
        localStorage.removeItem('editorValueAI');

        if (this.editorTxtAI != null && this.editorTxtAI.length !== 0) {
          this.textDivRef.nativeElement.innerHTML = this.editorTxtAI;
        }
      }
    }, 1000);
  }
  artroute() {
    var editortxt = '';
    editortxt = $('#editor').text();
    localStorage.setItem('editorValueAI', editortxt);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/article-rewriter'])
    );
    window.open(url, '_blank');
  }

  ngOnInit(): void {
    //   const isMobile = window.innerWidth <= 600;

    // if (isMobile) {
    //   this.router.navigate(['/app-plagiarism']);
    // } else {
    //   this.router.navigate(['/plagiarism-checker']);
    // }
    
    this.metaService.updateTags(
      'Plagiarism Checker Free for Students and Teachers',
      'Plagiarism checker is 100% free & accurate online plagiarism detector to check plagiarism and content duplication. Start with 1000 words without sign-up!',
      'https://www.grammarin.com/plagiarism-checker',
      'https://www.grammarin.com/assets/images/OG-Images/Plagiarism Checker.png',
      'Plagiarism Checker'
    );

    $('.tab_content').hide();
    $('.tab_content:first').show();

    $('ul.tabs li').click(function () {
      $('.tab_content').hide();
      var activeTab = $(this).attr('rel');
      $('#' + activeTab).fadeIn();

      $('ul.tabs li').removeClass('active');
      $(this).addClass('active');

      $('.tab_drawer_heading').removeClass('d_active');
      $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass('d_active');
    });
    $('.tab_container').css('min-height', function () {
      return $('.tabs').outerHeight() + 50;
    });

    $('.tab_drawer_heading').click(function () {
      $('.tab_content').hide();
      var d_activeTab = $(this).attr('rel');
      $('#' + d_activeTab).fadeIn();

      $('.tab_drawer_heading').removeClass('d_active');
      $(this).addClass('d_active');

      $('ul.tabs li').removeClass('active');
      $("ul.tabs li[rel^='" + d_activeTab + "']").addClass('active');
    });

    this.activeTab = 'q5';
    this.textfromAI();
  }
  recaptchaWidgetId: number | undefined;

  ////// hidden recaptcha strat
  captchaVisible: boolean = false;
  isCaptchaVerified: boolean = false;
  recaptchaMessage: string = '';

  handleButtonClick(): void {
    if (this.loaderAlert) {
      return;
    }
    $('#editor').find('span').contents().unwrap();
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().trim().split(/\s+/).length;

    // if (this.word_count >= 50 && this.word_count <= 300) {
    //     this.showCaptchaModal();
    // } else {
    //     this.showAlert("Enter 50 to 300 words to Check Plagiarism.", "");
    // }

    if (!this.subscribed_user)
      if (this.word_count >= 30 && this.word_count <= 1000) {
        this.showCaptchaModal();
      } else {
        this.showAlert('Enter 30 to 1000  words to Check Plagiarism.', '');
      }
    else if (this.subscribed_user)
      if (this.word_count >= 30 && this.word_count <= 10000) {
        this.showCaptchaModal();
      } else {
        this.showAlert('Enter 30 to 10,000  words to Check Plagiarism.', '');
      }
  }

  showCaptchaModal(): void {
    if (!this.captchaVisible) {
      this.captchaVisible = true;
      this.cdr.detectChanges();
      this.loadAndRenderTurnstile();
    } else {
      this.recaptchaMessage = 'Please complete the CAPTCHA.';
      this.color = '#721c24';
    }
  }

  loadAndRenderTurnstile(): void {
    if (typeof window['turnstile'] === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => this.renderTurnstile();
      script.onerror = () => console.error('Failed to load Turnstile script.');
      document.body.appendChild(script);
    } else {
      this.renderTurnstile();
    }
  }

  renderTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (!containerElement) {
      // console.error('Container element not found.');
      return;
    }

    window['turnstile'].render(containerElement, {
      sitekey: environment.CaptchaKey,
      size: 'normal',
      callback: (token: string) => this.onTurnstileSuccess(token),
      'error-callback': () => this.onTurnstileError(),
    });
    // console.log('Turnstile rendered successfully.');
  }

  onTurnstileSuccess(token: string): void {
    // console.log('Turnstile token received:', token);
    this.captchaToken = token;
    this.isCaptchaVerified = true;
    this.captchaVisible = false;
    this.recaptchaMessage = '';
    this.dummyplagapi();
  }

  onTurnstileError(): void {
    console.error('Turnstile error occurred.');
    this.captchaToken = null;
    this.recaptchaMessage = 'CAPTCHA verification failed. Please try again.';
    this.color = '#721c24';
  }

  resetTurnstile(): void {
    const containerElement = document.getElementById('recaptcha-container');
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].reset(containerElement);
      // console.log('Turnstile CAPTCHA reset.');
    } else {
      // console.error('Turnstile library not loaded.');
    }
  }

  ///// recaptcha end

  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }

  paramode() {
    this.Paragraphmode = true;
    this.mode_para = true;
    this.sentence_mode = false;
    this.Sentencesmode = false;
  }
  sentence_modetype() {
    this.Paragraphmode = false;
    this.sentence_mode = true;
    this.mode_para = false;
    this.Sentencesmode = true;
  }

  selectTab(tabId: string) {
    this.selectedTab = tabId;
  }
  public ngAfterViewInit(): void {
    const storedStatus = JSON.parse(
      localStorage.getItem('premium_user_done') || 'false'
    );
    // console.log(storedStatus, 'storedStatus');
    this.subscribed_user = storedStatus;
    this.profile_id = localStorage.getItem('profile_id');
    if (!this.profile_id) {
      this.profile_id = '1';
      this.isUserLoggedin = false;
    } else {
      this.isUserLoggedin = true;
    }
    this.textfromAI();

    this.getBrowserWidth();

    $('#editor').on('click', 'span, div > span', (event) => {
      let full_id = $(event.currentTarget).attr('id');
      let className = $(event.currentTarget).attr('class');

      if (
        className == 'plag_match_line' ||
        className == 'plag_match_line plag_match_line_highlight'
      ) {
        full_id = full_id.replace('plagSpan_', '');
        if (
          className == 'plag_match_line' ||
          className == 'plag_match_line plag_match_line_highlight'
        ) {
          this.hideDetailedSpanPlag(full_id);
          this.showDetailedSpanPlag(full_id);
          let val = document.querySelector('#scrollable-box').scrollTop;
          $('#scrollable-box')
            .stop()
            .animate(
              {
                scrollTop:
                  document.querySelector('#scrollable-box').scrollTop +
                  $('#plag_id' + full_id).offset().top -
                  185,
              },
              600
            );
        } else {
          this.hideDetailedSpan(full_id);
          this.hideDetailedSpanPlag(full_id);
        }
      }
    });

    this.setupContentClearListener();
    if (this.profile_id && this.profile_id != 1) {
      this.httpClient
        .getUserProfileContents(this.profile_id)
        .subscribe((data) => {
          //  console.log(data,"data")
          this.LoadProfileData(data);
        });
    }
  }
  public LoadProfileData(data: Response) {
    let receivedData = data;
    this.subscribed_user = receivedData['contents'][0][5];
    // console.log(this.subscribed_user, 'this.subscribed_user');
  }
  showTabResults(tabName: string) {
    throw new Error('Method not implemented.');
  }
  showDetailedSpan(index: any, className: any) {
    if (this.previous_plagerism_index === index) {
      $('#plagSpan_' + index).css({ background: 'none' });
      $('#plagSpan_' + index).removeClass('active plag_match_line_highlight');
      $('#collapse_plag_' + index).hide();
      $('#card-title' + index).removeClass('card-title-open');

      this.previous_plagerism_index = null;
      return;
    }

    if (this.previous_plagerism_index !== null) {
      $('#plagSpan_' + this.previous_plagerism_index).css({
        background: 'none',
      });
      $('#plagSpan_' + this.previous_plagerism_index).removeClass(
        'active plag_match_line_highlight'
      );
      $('#collapse_plag_' + this.previous_plagerism_index).hide();
      $('#card-title' + this.previous_plagerism_index).removeClass(
        'card-title-open'
      );
    }

    $('#plagSpan_' + index).css({ background: 'rgba(223, 147, 147, 0.49)' });
    $('#filled_big_sidebar').show();
    $('#card-title' + index).addClass('card-title-open');
    $('#plagSpan_' + index).addClass('active plag_match_line_highlight');
    $('#collapse_plag_' + index).show();

    this.previous_plagerism_index = index;
    throw new Error('Method not implemented.');
  }
  hideDetailedSpanPlag(full_id: any) {
    $('#plagSpan_' + full_id).css({ background: 'none' });
    $('#plagSpan_' + full_id).removeClass('active plag_match_line_highlight');
    $('#collapse_plag_' + full_id).hide();
    $('#card-title' + full_id).removeClass('card-title-open');
  }
  hideDetailedSpan(full_id: any) {
    throw new Error('Method not implemented.');
  }

  public getContent(event, text) {
    this.showParagraph = false;
    this.copiedtext = false;

    var ctrlDown = false,
      ctrlKey = 17,
      cmdKey = 91,
      vKey = 86,
      cKey = 67;
    document.getElementById('editor').setAttribute('contenteditable', 'true');
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().split(/\s+/).length;
    if (ctrlDown && event.keyCode == vKey) {
      this.showParagraph = false;
    }
    var old_text = document.getElementById('editor').textContent;

    var editorcontent = $('#editor');
  }
  onclickeditor(event: MouseEvent) {
    event.stopPropagation();
    if (this.char_count === 0 && !this.showParagraph) {
      this.word_count = 0;
      this.char_count = 0;
    }
    this.showParagraph = false;
    const sampleText = 'Enter your Text HereORUpload file from above options';
    const editorContent = $('#editor').text().trim();
    if (editorContent === sampleText) {
      this.word_count = 0;
      this.char_count = 0;
    }
    if (editorContent === '' || editorContent === sampleText) {
      this.word_count = 0;
      this.char_count = 0;
    } else {
      this.word_count = editorContent
        .split(/\s+/)
        .filter((word) => word.length > 0).length;
    }
  }

  setupContentClearListener(): void {
    document.getElementById('editor').addEventListener('input', (event) => {
      if ((<HTMLElement>event.target).innerText.trim() === '') {
        this.isContentCleared = true;
      } else {
        this.isContentCleared = false;
      }
    });
  }

  percentageresult;
  public doc_id = '';

  public dummyplagapi() {
    this.summatches = 0;
    this.sumofsources = 0;
    this.plagListings = [];

    this.showbuttons = false;
    $('#editor').find('span').contents().unwrap();
    this.char_count = $('#editor').text().length;

    this.word_count = $('#editor').text().trim().split(/\s+/).length;
    if (!this.isCaptchaVerified) {
      return;
    }
    if (this.word_count >= 30 ) {
      this.editortxt = $('#editor').text().trim();

      this.showbottombuttons = false;
      this.cleartxtbtn = true;

      this.plagresponse = true;
      this.loaderAlert = true;
      this.finalresult = 0;
      this.uniquefinal = 0;
      this.compleated = 0;
      this.plagListings = [];
      document
        .getElementById('editor')
        .setAttribute('contenteditable', 'false');
      if (window.innerWidth > 868 && this.profile_id !== '1') {
        let data2 = JSON.stringify({
          homeText: this.editortxt,
          profile_id: this.profile_id || '1',
        });

        let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

        this.httpClient.postResources(data2, url).subscribe((data) => {
          let receivedData = data;

          localStorage.setItem('editorValueAI', this.editortxt);
          this.doc_id = receivedData['new_doc_id'];

          this.router.navigate(['/plagiarismchecker'], {
            queryParams: { doc: this.doc_id },
          });

          const url = this.router.serializeUrl(this.router.createUrlTree(['']));
        });
        return;
      }

      var element = document.getElementById('editor');
      element.classList.add('plag-editor-after');
      let headers = new HttpHeaders({
        Authorization: environment.AuthorizationGIN,
      });
      headers = headers.set('Content-Type', 'application/json; charset=utf-8');

      this.https
        .post(
          environment.API_URL + '/api/plagBreakData',
          JSON.stringify({
            access_token: 'KW#2TI7G30fA(V',
            text: btoa(unescape(encodeURIComponent(this.editortxt))),
            profile_id: localStorage.getItem('profile_id') ?? '1',
          }),
          { headers: headers }
        )
        .subscribe((data) => {
          this.showbuttons = true;

          if (data['msg'] === 'Unable to break content.') {
            this.loaderAlert = false;

            this.showAlert(
              'Content is not suitable for Plagiarism Checking.',
              ''
            );
          } else {
            this.totallenghtofplag = data['data']['RES']['sentence_ids'].length;

            const getData = async () => {
              this.newquery = data['data']['RES']['sentence_ids'];
              return this.newquery;
            };
            getData();
            this.plagcontentid = data['data']['RES'].content_id;
            let valid_sentences = data['data']['RES'].valid_sentences;
            this.oneid = data['data']['RES']['sentence_ids'];
            var j = 0;
            for (let i = 0; i < this.totallenghtofplag; i++) {
              if (document.getElementById('editor').innerText.trim() !== '') {
                this.isContentCleared = false;
              }
              document
                .getElementById('editor')
                .setAttribute('contenteditable', 'false');
              if (this.isContentCleared) {
                this.loaderAlert = false;
                this.showbottombuttons = false;
                this.totallenghtofplag = 0;
                break;
              }

              let headers = new HttpHeaders({
                Authorization: environment.AuthorizationGIN,
              });
              headers = headers.set(
                'Content-Type',
                'application/json; charset=utf-8'
              );
              this.https
                .post(
                  environment.API_URL + '/api/checkPlagiarism',
                  {
                    access_token: 'KW#2TI7G30fA(V',
                    content_id: this.plagcontentid.toString(),
                    sentence_id: this.oneid[i].toString(),

                    exclude: this.excludeURL,
                  },
                  { headers: headers }
                )
                .subscribe((data) => {
                  const getData2 = async () => {
                    this.newquery = data['data']['0']['query_id'];

                    return this.newquery;
                  };

                  getData2();

                  this.showPlagResults = true;
                  this.showPlagTab = false;
                  if (data['data']['0']['details']['webs']) {
                    this.chcekit = data['data']['0'].query_id;
                  }
                  if (this.plagExcludeUrl) {
                    if (
                      data['data']['0']['details'].unique === false &&
                      data['data']['0']['details']['webs']['0'].url.replace(
                        /([^:])\/+/g,
                        '$1'
                      ) !== this.plagExcludeUrl.replace(/([^:])\/+/g, '$1')
                    ) {
                      if (data['data']['0']['details'].unique === false) {
                        this.finalresult += (1 / this.totallenghtofplag) * 100;
                        this.highlight(
                          data['data']['0']['details']['query'],
                          data['data']['0']['query_id']
                        );
                        this.plagListings.push({
                          index: this.newquery,
                          unique: data['data']['0']['details']['query'],
                          sentence: data['data']['0']['details'].unique,
                          url: data['data']['0']['details']['webs'][
                            'similarity_score'
                          ],
                        });
                      }
                    }
                  } else if (!this.plagExcludeUrl) {
                    if (this.mobilescreen) {
                      this.responseformodbile = true;
                    } else {
                      this.mobilescreen = false;
                      this.responseformodbile = false;
                    }

                    if (data['data']['0']['details'].unique === false) {
                      this.summatches += data['data']['0']['details'].matches;
                      this.sumofsources += data['data']['0']['details'].sources;

                      this.finalresult += (1 / this.totallenghtofplag) * 100;
                      const finalResultStr = this.finalresult.toString();

                      const finalResultParts = finalResultStr.split('.');

                      this.finalresult = parseInt(finalResultParts[0], 10);

                      this.highlight(
                        data['data']['0']['details']['query'],
                        data['data']['0']['query_id']
                      );
                      this.plagListings.push({
                        index: this.newquery,
                        unique: data['data']['0']['details'].unique,
                        sentence: data['data']['0']['details']['query'],
                        url: data['data']['0']['details']['webs'],
                        similarity_score:
                          data['data']['0']['details']['similarity_score'],
                        matchesurl: data['data']['0']['details'].matches,
                        sourcestotal: data['data']['0']['details'].sources,
                      });

                      this.plagListings = this.plagListings.slice().reverse();

                      for (let i = 0; i < this.plagListings.length; i++) {}
                    }
                  }

                  this.percentageresult = Math.floor(
                    (1 / this.totallenghtofplag) * 100
                  );

                  this.compleated = (++j / this.totallenghtofplag) * 100;
                  this.compleated = Math.round(this.compleated);

                  if (this.compleated == 100 && !this.isContentCleared) {
                    this.plagresponse = true;

                    document
                      .getElementById('editor')
                      .setAttribute('contenteditable', 'true');
                    this.showbottombuttons = true;

                    this.loaderAlert = false;
                    this.yesunique = false;
                    this.showPlagTab = false;
                    this.cleartxtbtn = false;
                    this.counter = Math.round(this.finalresult);

                    this.uniquefinal = 100 - this.counter;
                    this.finalresult = Math.round(this.finalresult);
                    this.uniquefinal = Math.round(this.uniquefinal);
                    if (this.finalresult == 0) {
                      this.yesunique = true;
                    }
                    this.can_check_plag = true;
                    this.plagListings.sort((a, b) => a.index - b.index);
                  }
                  if (data['data']['0']['details']['query']) {
                    this.querytesting = data['data']['0']['details']['query'];
                    var editortext = $('#editor').text();
                    if (
                      this.querytesting.length > 0 &&
                      editortext.indexOf(this.querytesting) > -1
                    ) {
                    } else {
                    }
                  }
                  this.alllist = data['data']['0']['details']['webs'];
                  this.firstval = data['data']['0']['details'].unique;
                });
            }
          }
        });
    } else {
      if (!this.subscribed_user) {
        this.showAlert('Enter 30 to 1000  words to Check Plagiarism.', '');
      } else if (this.subscribed_user) {
        this.showAlert('Enter 30 to 10,000  words to Check Plagiarism.', '');
      }

      // this.showAlert("Enter 50 to 300  words to Check Plagiarism.", "");
    }
  }
  // public dummyplagapi() {

  //   this.summatches = 0;
  //   this.sumofsources = 0;
  //   this.plagListings = [];

  //   this.showbuttons = false;
  //   $("#editor").find("span").contents().unwrap();
  //   this.char_count = $("#editor").text().length;

  //   this.word_count = $("#editor").text().trim().split(/\s+/).length;
  //   if (!this.isCaptchaVerified) {

  //     return;
  // }
  //   if (this.word_count >= 50 && this.word_count <= 300) {
  //     this.editortxt = $("#editor").text().trim();

  //     this.showbottombuttons = false;
  //     this.cleartxtbtn = true;

  //     this.plagresponse = true;
  //     this.loaderAlert = true;
  //     this.finalresult = 0;
  //     this.uniquefinal = 0;
  //     this.compleated = 0;
  //     this.plagListings = [];
  //     document.getElementById('editor').setAttribute('contenteditable', 'false');
  //     this.loaderAlert = true;
  //     let data2 = JSON.stringify({
  //       homeText: this.editortxt,
  //       profile_id: this.profile_id || '1',
  //     });

  //     let url = environment.API_URL + '/api/getNewDocIDForGuestByContents';

  //     this.httpClient.postResources(data2, url).subscribe((data) => {
  //       let receivedData = data;

  //       localStorage.setItem('editorValueAI', this.editortxt);
  //       this.doc_id = receivedData['new_doc_id'];

  //       this.router.navigate(['/plagiarismchecker'], {
  //         queryParams: { doc: this.doc_id },
  //       });

  //       const url = this.router.serializeUrl(this.router.createUrlTree(['']));

  //     });
  //   }
  //   else {

  //     this.showAlert("Enter 50 to 300  words to Check Plagiarism.", "");
  //   }

  // }

  showAlert(message, selector) {
    this.errorAlerts = message;
    $(selector).css('border-color', 'red');
    this.error = true;
    $('#errorAlerts').show();
    setTimeout(() => {
      $('#errorAlerts').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.error = false;
    }, 4000);
  }

  showSuccess(message, selector) {
    this.successAlert = message;
    this.success = true;
    $('#successAlert').show();
    setTimeout(() => {
      $('#successAlert').hide();
      $(selector).css('border-color', '#e7e7ec');
      this.success = false;
    }, 4000);
  }

  closeErrorDiv() {
    this.error = false;
  }

  public highlight(text, id) {
    var inputText = document.getElementById('editor');
    var innerHTML = inputText.innerHTML;
    var index = innerHTML.indexOf(text);

    if (index >= 0) {
      var spanId = 'plagSpan_' + id;
      var highlightedText = innerHTML.substring(index, index + text.length);
      var newHTML =
        innerHTML.substring(0, index) +
        `<span id="${spanId}" style="cursor: pointer; background: none;" class="plag_match_line">${highlightedText}</span>` +
        innerHTML.substring(index + text.length);

      inputText.innerHTML = newHTML;

      document.getElementById(spanId).addEventListener('click', () => {
        this.showDetailedSpanPlag(id);
      });
    }
  }

  onInputChange(excludeURL) {
    this.excludeURL = excludeURL;
  }

  public showDetailedSpanPlag(index: number) {
    if (this.previous_plagerism_index === index) {
      $('#plagSpan_' + index).css({ background: 'none' });
      $('#plagSpan_' + index).removeClass('active plag_match_line_highlight');
      $('#collapse_plag_' + index).hide();
      $('#card-title' + index).removeClass('card-title-open');

      this.previous_plagerism_index = null;
      return;
    }

    if (this.previous_plagerism_index !== null) {
      $('#plagSpan_' + this.previous_plagerism_index).css({
        background: 'none',
      });
      $('#plagSpan_' + this.previous_plagerism_index).removeClass(
        'active plag_match_line_highlight'
      );
      $('#collapse_plag_' + this.previous_plagerism_index).hide();
      $('#card-title' + this.previous_plagerism_index).removeClass(
        'card-title-open'
      );
    }

    $('#plagSpan_' + index).css({ background: 'rgba(223, 147, 147, 0.49)' });
    $('#filled_big_sidebar').show();
    $('#card-title' + index).addClass('card-title-open');
    $('#plagSpan_' + index).addClass('active plag_match_line_highlight');
    $('#collapse_plag_' + index).show();

    this.previous_plagerism_index = index;
  }
  sampletext() {
    $('#editor').html(
      "We all are aware of the fact that plagiarism can destroy our careers and websites' credibility. Suppose you have detected that some proportion of your text is plagiarized. In that case, you can opt to use the best article rewriter to make your plagiarized sentences and display their plagiarism-free version in a matter of seconds. It means that it's not only wasted an hour or more trying to rewrite plagiarism from the text yourself and then putting to some responsibility for both of these demanding jobs and providing you 100% unique content in the blink of an eye. There is plagiarism, but only some platforms will provide you with the quality Grammarin offers. This article is jam-packed with top-notch features to facilitate you in the best way possible. You can enjoy the following features."
    );
    this.char_count = $('#editor').text().length;
    this.word_count = $('#editor').text().trim().split(' ').length;
    this.showParagraph = false;
  }
  pasteText(): void {
    navigator.clipboard
      .readText()
      .then((pastedText) => {
        document.execCommand('insertText', false, pastedText);

        $('#editor').html(pastedText);
        this.char_count = $('#editor').text().length;
        this.word_count = $('#editor').text().trim().split(' ').length;
      })
      .catch((err) => {
        console.error('Failed to read clipboard contents: ', err);
      });
    this.showParagraph = false;
  }
  ////////////// Upload file function from browser //////////
  public uploadFileSaveRedirect(event): void {
    const files: FileList = this.fileInput.nativeElement.files;

    var filetype = 'pdf';
    if (files[0].size > 5243000) {
      this.showAlert('File should be less than 5 MB', '');
    } else {
      this.loaderAlert = true;
      let input = event.target;

      $('.hideUpload').hide('slow');
      this.showbottombuttons = false;
      var element = document.getElementById('editor');
      element.classList.remove('plag-editor-after');
      var testingnew = document.getElementById('editor');
      testingnew.textContent = '';
      this.word_count = 0;
      this.char_count = 0;
      this.menuafterresponse = false;

      this.showParagraph = true;
      this.plagListings = [];
      this.finalresult = 0;
      this.uniquefinal = 0;
      this.plagresponse = false;
      this.showbuttons = false;
      this.showParagraph = false;

      if (testingnew.textContent != '') {
        testingnew.textContent = '';
      }
      this.httpClient.uploadfilefrombrowser(files).subscribe(
        (data) => {
          this.loaderAlert = false;
          let receivedData = data;
          0;
          $('#editor').html(receivedData['RetCnt']);
          this.getContent('', receivedData['RetCnt']);
          this.char_count = $('#editor').text().length;
          this.word_count = $('#editor').text().trim().split(/\s+/).length;
          this.plagListings = [];

          this.finalresult = 0;
          this.uniquefinal = 0;
          this.fileInput.nativeElement.value = '';
        },
        (error) => {
          this.loaderAlert = false;
          this.fileInput.nativeElement.value = '';

          this.showAlert(
            'Unable to proceed with a password protected file',
            ''
          );
        }
      );
    }
  }

  getFileType(fileName: string): string {
    const fileExtension = fileName.split('.').pop();
    return fileExtension ? fileExtension.toLowerCase() : '';
  }
  public plaglinks(query) {
    window.open(query, '_blank');
  }
  uploadFileToServer(fileLink: string, fileType: string): void {
    this.loaderAlert = true;
    this.httpClient.dropboxfile(fileType, fileLink).subscribe((data) => {
      let receivedData = data;
      this.plagListings = [];
      this.finalresult = 0;
      this.uniquefinal = 0;
      $('#editor').html(receivedData['RetCnt']);
      this.getContent('', receivedData['RetCnt']);
      this.loaderAlert = false;
    });
  }

  /////////// copy and download function
  copyText() {
    const editorElement = this.editor.nativeElement;
    if (editorElement) {
      const range = document.createRange();
      range.selectNode(editorElement);
      window.getSelection()?.removeAllRanges();
      window.getSelection()?.addRange(range);

      try {
        document.execCommand('copy');

        this.copiedtext = true;
        this.copried_txt = 'copied';
        $('#copytextId').hide();
        $('#copried_txt').show();
        setTimeout(function () {
          $('#copried_txt').hide();
          $('#copytextId').show();
          this.copiedtext = false;
        }, 2000);
      } catch (err) {
        this.copiedtext = false;
      }

      window.getSelection()?.removeAllRanges();
    }
  }

  ////////////// clear text function //////////
  public clear_txt() {
    document.getElementById('editor').setAttribute('contenteditable', 'true');
    this.summatches = 0;
    this.sumofsources = 0;
    this.showbottombuttons = false;
    var element = document.getElementById('editor');
    element.classList.remove('plag-editor-after');
    this.word_count = 0;
    this.char_count = 0;
    this.showbuttons = false;

    this.menuafterresponse = false;
    this.loaderAlert = false;
    this.showParagraph = true;
    this.plagListings = [];
    this.responseformodbile = false;
    this.finalresult = 0;
    this.uniquefinal = 0;
    var editortextremove = $('#editor').text();
    editortextremove = '';
    var testingnew = document.getElementById('editor');
    testingnew.textContent = '';
    this.plagresponse = false;
  }

  public getBrowserWidth = function () {
    if (window.innerWidth <= 430) {
      this.mobilescreen = true;
      this.responseformodbile = false;

      return 'xs';
    } else if (window.innerWidth < 991) {
      this.mobilescreen = true;
      this.responseformodbile = false;

      return 'sm';
    } else if (window.innerWidth < 1199) {
      this.mobilescreen = true;
      this.responseformodbile = false;

      return 'md';
    } else {
      this.mobilescreen = false;
      this.responseformodbile = false;

      return 'lg';
    }
  };
  ///////////// outside click fun
  @HostListener('document:click', ['$event.target'])
  onClickOutside(event) {
    const clickedElementId = event.id;
    var text = $('#editor').text();
    const excludedButtonIds = [
      'checkgrammar-btn-art',
      'downloadfile',
      'copy-btn',
      'retry-btn',
      'footerlinksforroute',
    ];
    const editorContent = this.editor.nativeElement.innerText.trim();
    if (editorContent !== '') {
      return;
    }
    if (excludedButtonIds.includes(clickedElementId)) {
      return;
    }
    document.addEventListener('click', (event) => {
      if (!this.editor.nativeElement.contains(event.target as Node)) {
        if (!this.word_count || !this.char_count) {
          this.showParagraph = true;
        } else {
          this.showParagraph = false;
        }
        this.word_count = 0;
        this.char_count = 0;

        const editorContent = $('#editor').text().trim();
        this.word_count = editorContent
          .split(/\s+/)
          .filter((word) => word.length > 0).length;
        this.char_count = editorContent.length;
      }
    });
  }
  ////// on paste fun
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    this.showParagraph = false;
    const clipboardData = event.clipboardData;
    const targetElement = event.target as HTMLElement;

    if (
      (targetElement.id === 'editor' || targetElement.closest('#editor')) &&
      clipboardData &&
      clipboardData.getData
    ) {
      const pastedContent = clipboardData.getData('text/plain');

      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);

        if (!range.collapsed) {
          range.deleteContents();
          range.insertNode(document.createTextNode(pastedContent));
        } else {
          range.insertNode(document.createTextNode(pastedContent));
        }

        const newRange = document.createRange();
        newRange.selectNodeContents(range.endContainer);
        newRange.collapse(false);

        selection.removeAllRanges();
        selection.addRange(newRange);
      }

      this.showParagraph = false;

      this.char_count = $('#editor').text().length;
      this.word_count = $('#editor').text().trim().split(/\s+/).length;
    }
  }

  public async generatePdf(
    htmlElementId: string,
    pdfFileName: string
  ): Promise<void> {
    const element = document.getElementById(htmlElementId.trim());

    if (element) {
      try {
        this.showpdfhtml = true;
        this.editortxtforpdf = $('#editor').text();
        $('#editortxtforpdf').html(this.editortxtforpdf);

        const canvas = await html2canvas(element);
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(pdfFileName);
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    } else {
      console.error('Element not found:', htmlElementId);
      this.showpdfhtml = false;
    }
    this.showpdfhtml = false;
  }
  public downloadText(): void {
    const textContent = this.editor.nativeElement.innerText;
    if (textContent && textContent.trim() !== '') {
      const blob = new Blob([textContent], { type: 'text/plain' });
      const a = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = 'PC_text.txt';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  }

  public hideDetailedSpanRight(spanId) {
    var chunkid = document.getElementById(spanId);

    if ($('#small_errror_' + spanId).hasClass('active')) {
      $('#collapse_alerts' + spanId).focusout();
      $('#collapse_alerts' + spanId).hide();
      $('#collapse_alerts' + spanId).css('display', 'none');
      $('#card-title' + spanId).removeClass('card-title-open');
      $('#small_errror_' + spanId).removeClass('active');
      $('#edit_btn' + spanId).css('display', 'block');
      $('#igno_corr' + spanId).css('display', 'none');
      $('#gc_correct' + spanId).removeAttr('style');
      $('#collapse_span' + spanId).show();
      $('#span_' + spanId).css({ background: 'none' });

      $('#span_' + this.oldUnderlineSpan).css({ background: 'none' });
    }
  }

  /// dropbox  gDriveUpload functionn////////
  public gDriveUpload() {
    gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
  }

  public onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult
    );
  }

  public onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }
  isExport: boolean = false;
  public handleAuthResult(authResult) {
    $('#UpFileModal').modal('hide');

    let src;

    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        let view = new google.picker.View(google.picker.ViewId.DOCS);

        view.setMimeTypes(
          'application/pdf,application/txt,text/plain,application/vnd.oasis.opendocument.text,application/vnd.google-apps.document,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        );

        let pickerBuilder = new google.picker.PickerBuilder();
        let picker = pickerBuilder
          .enableFeature(google.picker.Feature.MINE_ONLY)
          .setOAuthToken(authResult.access_token)
          .addView(view)
          .addView(new google.picker.DocsUploadView())
          .setCallback(function (e) {
            if (e.action == google.picker.Action.PICKED) {
              var fileId = e.docs[0].id;
              var file = e.docs[0].url;
              var files = e.docs[0];
              if (files.sizeBytes > 5243000) {
                this.lodershow = false;

                swal({
                  background: '#FFFFFF',
                  title: 'Error',
                  html: `
                  <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                    background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                    <div class="text-center" style="margin-top: 9%;">
                      <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                      <div style="width: 323px; height: 64px; margin-left: 77px;">
                        <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                          File should be less than 5 MB
                        </p>
                      </div>
                      <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                        border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                        class="mt-4 butn-alert">Ok</button>
                    </div>
                  </div>
                `,
                  showConfirmButton: false,
                  width: '323px',
                  timer: 4000,
                });

                setTimeout(() => {
                  const okButton = document.getElementById('swal-ok-button');
                  if (okButton) {
                    okButton.addEventListener('click', () => {
                      swal.close();
                    });
                  }
                }, 0);
              } else {
                if (e.docs[0].name.split('.')[1] === 'pdf') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';
                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'pdf',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('#editor').html(return_data.RetCnt);

                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id,
                      });
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
        <div class="text-center" style="margin-top: 9%;">
          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
          <div style="    width: 369px; height: 64px; margin-left: 39px;">
            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
            </p>
          </div>
          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
            class="mt-5 butn-alert">Ok</button>
        </div>
      </div>
    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name.split('.')[1] === 'txt') {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://drive.google.com/u/0/uc?id=' +
                    fileId +
                    '&export=download';

                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'txt',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('#editor').html(return_data.RetCnt);

                      this.hideothers = true;
                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id,
                      });
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
                      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                        <div class="text-center" style="margin-top: 9%;">
                          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                          <div style="    width: 369px; height: 64px; margin-left: 39px;">
                            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                            </p>
                          </div>
                          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                            class="mt-5 butn-alert">Ok</button>
                        </div>
                      </div>
                    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                } else if (e.docs[0].name) {
                  let filelink2 = file + fileId;
                  let linksvalue =
                    'https://docs.google.com/feeds/download/documents/export/Export?id=' +
                    fileId +
                    '&exportFormat=docx';
                  if (localStorage.getItem('profile_id')) {
                    var profile_id = localStorage.getItem('profile_id');
                  } else {
                    var profile_id = '1';
                  }
                  $.ajax({
                    url: environment.API_URL + '/api/downloadFromDrive',
                    type: 'post',

                    dataType: 'json',
                    data: {
                      profile_id: profile_id,
                      hash: authResult.access_token,
                      file_path: fileId,
                      file_type: 'docx',
                      create_chunks: 'false',
                    },
                    beforeSend: function (xhr) {
                      xhr.setRequestHeader(
                        'Authorization',
                        +localStorage.getItem('token')
                      );
                    },

                    success: function (return_data) {
                      $('#editor').html(return_data.RetCnt);

                      let data2 = JSON.stringify({
                        homeText: return_data.RetCnt,
                        profile_id: profile_id,
                      });
                    },
                    error: function (data) {
                      swal({
                        background: '#FFFFFF',
                        title: 'Error',
                        html: `
                      <div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 468px; height: 360px;
                        background-color: white; z-index: 9999999999999999; border-radius: 4px; border: 1px solid #E3E3F0;">
                        <div class="text-center" style="margin-top: 9%;">
                          <img src="/assets/images/paraphrasing tool/alert.svg" alt="Alert" />
                          <div style="    width: 369px; height: 64px; margin-left: 39px;">
                            <p class="error mt-4" style="font-size: 20px; font-weight: 500; line-height: 33.89px;">
                              This file is restricted. Update the public access of your file from \"Restricted\" to \"Anyone with the link.\"
                            </p>
                          </div>
                          <button id="swal-ok-button" style="color: white; background-color: black; border: 1px solid black;
                            border-radius: 8px; width: 150px; height: 50px; font-size: 16px; font-weight: 600;"
                            class="mt-5 butn-alert">Ok</button>
                        </div>
                      </div>
                    `,
                        showConfirmButton: false,
                        width: '323px',
                        timer: 4000,
                      });

                      setTimeout(() => {
                        const okButton =
                          document.getElementById('swal-ok-button');
                        if (okButton) {
                          okButton.addEventListener('click', () => {
                            swal.close();
                          });
                        }
                      }, 0);
                    },
                  });
                }
              }
            }
          })
          .build();
        picker.setVisible(true);
      }
    }
  }
  openDropboxChooser(): void {
    const options = {
      success: (files: any) => {
        let fileType = this.getFileType(files[0].name);

        if (fileType === 'docx' || fileType === 'pdf' || fileType === 'txt') {
          this.uploadFileToServer(files[0].link, fileType);
        } else {
          // console.error('Unsupported file type');
        }
      },
      cancel: () => {},
      linkType: 'direct',
      multiselect: false,
      extensions: ['.docx', '.pdf', '.txt'],
      sizeLimit: 1024 * 1024 * 5,
    };
    Dropbox.choose(options);
  }

  toggleDropdowns(dropdown: string) {
    if (this.activeDropdown === dropdown) {
      this.activeDropdown = '';
    } else {
      this.activeDropdown = dropdown;
    }
  }

  toggleDropdown() {
    this.isDropdownVisible = !this.isDropdownVisible;
  }

  selectLanguage(name: string, icon: string) {
    this.selectedLanguage.name = name;
    this.selectedLanguage.icon = icon;
    this.isDropdownVisible = false;
  }

  checkUserStatus() {
    setTimeout(() => {
      this.isUserLoggedin = true;
      this.cd.detectChanges();
    }, 1000);
  }

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }

  onCopyPaste(event: ClipboardEvent): void {
    const pastedData = (event.clipboardData || window.clipboardData).getData(
      'text'
    );

    this.excludeURL = pastedData;
  }
  @ViewChild('editor') textDivRef!: ElementRef;
  deleteText() {
    this.loaderAlert = true;
    if (this.textDivRef) {
      this.loaderAlert = true;
      this.textDivRef.nativeElement.innerHTML = '';
    }

    this.word_count = 0;
    this.char_count = 0;
    this.loaderAlert = false;
    this.showParagraph = true;
    const result = document.getElementById('editor2');
    if (this.plagresponse) {
      this.plagresponse = false;
      this.showbottombuttons = false;
      result.innerHTML = '';
    }
  }

  //  objects objects objects

  executeAction(action: string) {
    if (this[action] && typeof this[action] === 'function') {
      this[action]();
    } else {
      console.error(`Action "${action}" is not a valid method.`);
    }
  }

  contentArray = [
    {
      showParagraph: true,
      header: 'Upload Your Content',
      paragraph: 'Type or Paste AI Text here',
      buttons: [
        {
          text: 'Sample Text',
          icon: 'copyIcon',
          action: 'sampletext',
        },
        {
          text: 'Paste Text',
          icon: 'copyIcon',
          action: 'pasteText',
        },
      ],
    },
  ];

  plagiarismSteps = [
    {
      icon: 'uploadTextIcon',
      text: 'Upload the text file or paste the textual content directly in the given field.',
    },
    {
      icon: 'checkPlagiarismIcon',
      text: 'Click on the Check Plagiarism button to start the duplication-finding procedure.',
    },
    {
      icon: 'plagiarismCheckerscanIcon',
      text: 'The AI plagiarism checker will scan your text and compare it with billions of pages.',
    },
    {
      icon: 'downloadReportPlagiarismIcon',
      text: 'Click on the Download Report to fetch the detailed result report on your local device.',
    },
  ];
  plagiarismTabs = [
    { id: 'tab1', icon: 'advancedTechnologyIcon', text: 'Advanced Technology' },
    { id: 'tab2', icon: 'freeToUseIcon', text: 'Free to Use' },
    {
      id: 'tab3',
      icon: 'unlimitedFileCheckingIcon',
      text: 'Unlimited File Checking',
    },
    { id: 'tab4', icon: 'accurateResultsIcon', text: '100% Accurate Results' },
    {
      id: 'tab5',
      icon: 'multipleUploadingOptionsIcon',
      text: 'Multiple Uploading Options',
    },
  ];
   //  for result scetion hide or display 
    isMobile: boolean = window.innerWidth <= 767;
  
    @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
      const window = event.target as Window;
      this.screenWidth = window.innerWidth;
      this.isMobile = this.screenWidth <= 767;
    }
    screenWidth: number;
  
 
      //  for result scetion hide or display
}
